var render = function render(){var _vm=this,_c=_vm._self._c;return _c('van-checkbox-group',[_c('van-checkbox',{model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("复选框")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }